<app-popover-layout>
  <app-x-common-toolbar-item>
    <app-x-icon-button [name]="'logo-32'" style="width: 32px; height: 32px"></app-x-icon-button>
    <app-x-icon-button-selector
      [cdkMenuTriggerFor]="mainMenu"
    ></app-x-icon-button-selector>
  </app-x-common-toolbar-item>
  
  <app-x-common-toolbar-item class="board-title">
    {{ boardName }}
    <button 
      class="case-asset-info-toggle" 
      (click)="onToggleCaseAssetInfoClick()"
      [attr.aria-label]="'dashboard_toolbar_toggle_case_asset_info' | translate">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1622_7199)">
          <path d="M16.5 19V15H14.5V16H15.5V19H14V20H18V19H16.5Z" fill="black"/>
          <path d="M16 12C15.8517 12 15.7067 12.044 15.5833 12.1264C15.46 12.2088 15.3639 12.3259 15.3071 12.463C15.2503 12.6 15.2355 12.7508 15.2644 12.8963C15.2934 13.0418 15.3648 13.1754 15.4697 13.2803C15.5746 13.3852 15.7082 13.4567 15.8537 13.4856C15.9992 13.5145 16.15 13.4997 16.287 13.4429C16.4241 13.3861 16.5412 13.29 16.6236 13.1667C16.706 13.0433 16.75 12.8983 16.75 12.75C16.75 12.5511 16.671 12.3603 16.5303 12.2197C16.3897 12.079 16.1989 12 16 12Z" fill="black"/>
          <path d="M21 22H11C10.7349 21.9997 10.4807 21.8942 10.2932 21.7068C10.1058 21.5193 10.0003 21.2651 10 21V11C10.0003 10.7349 10.1058 10.4807 10.2932 10.2932C10.4807 10.1058 10.7349 10.0003 11 10H21C21.2651 10.0003 21.5193 10.1058 21.7068 10.2932C21.8942 10.4807 21.9997 10.7349 22 11V21C21.9997 21.2651 21.8942 21.5193 21.7068 21.7068C21.5193 21.8942 21.2651 21.9997 21 22ZM11 11V21H21V11H11Z" fill="black"/>
        </g>
        <defs>
          <clipPath id="clip0_1622_7199">
            <rect width="32" height="32" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </button>
  </app-x-common-toolbar-item>

  <app-x-common-toolbar-item class="export-button">
    <app-x-button 
      [size]="'32'" 
      [style]="'filled-black'" 
      (click)="onExportPdfClick()">
      <svg-icon [name]="'export-pdf-20'" style="width: 20px; height: 20px"></svg-icon>
      {{ 'dashboard_toolbar_export_pdf' | translate }}
    </app-x-button>
  </app-x-common-toolbar-item>
</app-popover-layout>

<ng-template #mainMenu>
  <app-x-menu
    [items]="[
      { id: 'home', text: ('home' | translate) },
      { id: 'pref', text: ('preferences' | translate), submenu: mapDetailedSettingsMenu },
      { id: 'lng', text: ('dashboard_toolbar_language' | translate), submenu: languageMenu}
    ]"
    [withSelectedIcons]="false"
    (activeChange)="onMenuItemClick($event)"
  ></app-x-menu>
</ng-template>

<ng-template #mapDetailedSettingsMenu>
  <app-x-menu
    [items]="detailedSettingItems"
    [withSelectedIcons]="false"
    (activeChange)="onToggleChange($event)"
  ></app-x-menu>
</ng-template>

<ng-template #languageMenu>
  <app-x-menu
    [items]="[
      { id: 'en', text: ('dashboard_toolbar_language_english' | translate) },
      { id: 'id', text: ('dashboard_toolbar_language_indonesian' | translate) },
    ]"
    [active]="translate.currentLang"
    (activeChange)="onLanguageChange($event)"
  ></app-x-menu>
</ng-template>

